import React from 'react';
import ReactDOM from 'react-dom/client';
import { Amplify } from 'aws-amplify';
import './index.css';
import App from './App';
import awsExports from './aws-exports';
import { loadSavedTheme, THEMES, applyTheme, DEFAULT_THEME_ID } from './themes';

Amplify.configure(awsExports);

// Apply persisted theme before first paint (no colour flash).
// First-time visitors get the default theme (Sunset FC).
if (localStorage.getItem('topqik_theme_id') || localStorage.getItem('goalcast_theme_id')) {
  loadSavedTheme();
} else {
  const defaultTheme = THEMES.find(t => t.id === DEFAULT_THEME_ID);
  if (defaultTheme) applyTheme(defaultTheme);
}

const root = ReactDOM.createRoot(
  document.getElementById('root') as HTMLElement
);
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);
